module.exports = __webpack_public_path__ + "static/img/shezhi_chongzhi.ef089ee3.png";